import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { Loader } from "../loaders/Loader";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { prepareTableData } from "../../features/dataFormatFunctions/dataFormatter";
import { Button } from "primereact/button";
import { IndorImages, getIndorImageSrc } from "../../features";
import { getBasicTableBasicBody } from "../tablesShared/tableTools/tableCellBodies";
import { excelExport } from "../tablesShared/tableTools/tableExport";
import { classNames } from "primereact/utils";
import { roadBedFiltersOptions } from "../map/mapAddons/mapOverlayWidget/roadBedLayerSegmentsOverlay";
import { roadCategoryFiltersOptions } from "../map/mapAddons/mapOverlayWidget/roadCategorySegmentsOverlay";
import ToastMessageContainer from "../toastMessageContainer/ToastMessageContainer";

// Шаблон колонок для таблицы покрытия типов дорожных одежд
const columnsRoadBedLayers: any = [
    {
        headerName: "Капитальный",
        pdfHeader: "Капитальный, км",
        field: "fundamental",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Переходный",
        pdfHeader: "Переходный, км",
        field: "transitional",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Облегчённый",
        pdfHeader: "Облегчённый, км",
        field: "lightweight",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Низший",
        pdfHeader: "Низший, км",
        field: "inferior",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Итого, км",
        pdfHeader: "Итого, км",
        field: "total",
        valueType: "float",
        width: 100,
        align: "center"
    },
]

// Шаблон колонок для таблицы покрытия категорийных участков
const columnsRoadCategorySegments: any = [
    {
        headerName: "IA",
        pdfHeader: "IA, км",
        field: "IA",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "IБ",
        pdfHeader: "IБ, км",
        field: "IБ",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "IВ",
        pdfHeader: "IВ, км",
        field: "IВ",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "II",
        pdfHeader: "II, км",
        field: "II",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "III, км",
        pdfHeader: "III, км",
        field: "III",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "IV, км",
        pdfHeader: "IV, км",
        field: "IV",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "V, км",
        pdfHeader: "V, км",
        field: "V",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Другие",
        pdfHeader: "Другие, км",
        field: "others",
        valueType: "float",
        width: 100,
        align: "center"
    },
    {
        headerName: "Итого",
        pdfHeader: "Итого, км",
        field: "total",
        valueType: "float",
        width: 100,
        align: "center"
    },
]

// Компонент - таблица - статистическая сводка по информации на карте
export function StatisticsTableUnderMap() {
    let tableValue: any = []
    let columns: any = []
    let headerGroup

    const containsRoadBedLayersSegments = window.location.pathname.split('/')[4] === ("RoadBedLayerSegments");
    const containsRoadCategorySegments = window.location.pathname.split('/')[4] === ("RoadCategorySegments");

    const [paginatorExportLoader, setPaginatorExportLoader] = useState<boolean>()

    const pavementGroups = useAppSelector(state => state.roadBedLayerSegments.pavementGroups)
    const categoryGroups = useAppSelector(state => state.roadCategorySegments.categoryGroups)

    if (containsRoadBedLayersSegments && pavementGroups) {
        let roadBedLayersStatisticsValue = {}
        let totalLength = 0;
        Object.keys(roadBedFiltersOptions).map((key) => {
            let length = pavementGroups?.find((item: any) => item.RoadbedType === roadBedFiltersOptions[key].name)?.Length
            Object.assign(roadBedLayersStatisticsValue, { [key]: length })
            if (length) {
                totalLength += length;
            }
        })
        Object.assign(roadBedLayersStatisticsValue, { total: totalLength })
        tableValue = [roadBedLayersStatisticsValue]
        columns = columnsRoadBedLayers.slice()
        tableValue = prepareTableData(tableValue, columns)
        headerGroup = (
            <ColumnGroup>
                <Row>
                    <Column header="Типы дорожной одежды, км" colSpan={4} align="center" />
                    <Column header="Итого, км" colSpan={1} rowSpan={2} align="center" />
                </Row>
                <Row>
                    <Column header="Капитальный" colSpan={1} align="center" />
                    <Column header="Переходный" colSpan={1} align="center" />
                    <Column header="Облегчённый" colSpan={1} align="center" />
                    <Column header="Низший" colSpan={1} align="center" />
                </Row>
            </ColumnGroup>
        );
    }

    if (containsRoadCategorySegments && categoryGroups) {
        let roadCategorySegmentsStatisticsValue = {}
        let totalLength = 0;
        Object.keys(roadCategoryFiltersOptions).map((key) => {
            let length = categoryGroups.find((item: any) => item.CategoryId === roadCategoryFiltersOptions[key].categoryId)?.Length
            Object.assign(roadCategorySegmentsStatisticsValue, { [key]: length })
            if (length) {
                totalLength += length;
            }
        })
        Object.assign(roadCategorySegmentsStatisticsValue, { total: totalLength })
        tableValue = [roadCategorySegmentsStatisticsValue]
        columns = columnsRoadCategorySegments.slice()
        tableValue = prepareTableData(tableValue, columns)
        headerGroup = (
            <ColumnGroup>
                <Row>
                    <Column header="Технические категории, км" colSpan={8} align="center" />
                    <Column header="Итого, км" colSpan={1} rowSpan={2} align="center" />
                </Row>
                <Row>
                    <Column header="IA" colSpan={1} align="center" />
                    <Column header="IБ" colSpan={1} align="center" />
                    <Column header="IВ" colSpan={1} align="center" />
                    <Column header="II" colSpan={1} align="center" />
                    <Column header="III" colSpan={1} align="center" />
                    <Column header="IV" colSpan={1} align="center" />
                    <Column header="V" colSpan={1} align="center" />
                    <Column header="Другие" colSpan={1} align="center" />
                </Row>
            </ColumnGroup>
        );
    }

    async function exportPaginatorExcel() {
        if (!paginatorExportLoader) {
            let valueToExport: any = []
            let requiredFields: any = []
            let fieldsLocal = []
            setPaginatorExportLoader(true)
            columns.map((col: any) => {
                if (col.pdfHeader && !col.hidden) {
                    requiredFields.push(col.field)
                    fieldsLocal.push({ field: col.field, name: col.pdfHeader })
                }
            })
            // форматирование значений для экспорта 
            tableValue && tableValue.map((item: any) => {
                let object: any = {}
                requiredFields.map((field: any, index: any) => {
                    if (Object.keys(item).includes(field)) {
                        object[index] = item[field]
                    }
                })
                valueToExport.push(object)
            })
            excelExport(valueToExport, columns, '')
            setTimeout(() => {
                setPaginatorExportLoader(false)
            }, 100)
        }
    }

    const paginatorRight = (
        <Button className="paginator-export-button" onClick={exportPaginatorExcel} type="button">
            {paginatorExportLoader
                ?
                <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span className="paginator-export-loading-text">Загрузка...</span>
                </>
                :
                <img src={getIndorImageSrc(IndorImages.ExcelExport)} />
            }
        </Button>
    )

    let tableDivStyleClassname = classNames({
        "road-bed-layers-map-table-div": containsRoadBedLayersSegments,
        "road-category-map-table-div": containsRoadCategorySegments
    })

    return (
        <>
            <div className={tableDivStyleClassname}>
                <ToastMessageContainer />
                <DataTable
                    value={tableValue}
                    scrollable
                    size="normal"
                    removableSort
                    selectionMode="single"
                    dataKey="id"
                    rows={200}
                    loadingIcon={<Loader />}
                    headerColumnGroup={headerGroup}
                    emptyMessage="Данных нет"
                    paginator
                    paginatorTemplate=""
                    paginatorRight={paginatorRight}>
                    {/* Столбцы таблицы */}
                    {columns?.map((item: any, idx: any) => (
                        <Column
                            key={idx}
                            field={item.field}
                            sortable={item.canBeSorted}
                            header={item.header ? item.header : item.headerName}
                            hidden={item?.hidden}
                            align={item.align}
                            dataType={(item.valueType === "float" || item.valueType === "int") ? "numeric" : undefined}
                            body={(rowData: any) => getBasicTableBasicBody(rowData, item.field)}
                        >
                        </Column>
                    ))}
                </DataTable>
            </div>
        </>
    );
}